// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3dEhA","rootSmall":"AddTileButton_rootSmall__B7ICQ"};